import React, { useEffect } from "react";
import { track } from "utils";

const CreditMonitoringEnrollmentModal = ({ dismiss }) => {
  useEffect(() => {
    track("CREDIT_MONITORING_ENROLLMENT_MODAL_SHOWN");
  }, []);
  return (
    <div
      className="py-8 px-8 text-center flex flex-col items-center bg-neutral-50"
      style={{ width: "460px" }}
    >
      <div className="font-black text-3xl mb-5">TomoCredit Score</div>
      We would like to extend you Free Credit Monitoring to improve your credit
      health.
      <button
        className={`inline-block rounded-sm mt-8 px-24 py-3 text-white font-semibold bg-green-primary cursor-pointer shadow`}
        onClick={dismiss}
      >
        View Now
      </button>
    </div>
  );
};

export default CreditMonitoringEnrollmentModal;
